// TODO: Fix eslint errors.
/* eslint-disable */
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import Checkbox from '@UI/Checkbox';
import InputField from '@UI/InputField';
import Button from '@UI/Button';
import SelectField from '@UI/SelectField';
import OccupationField from '@Components/OccupationField';
import LocationField from '@Components/LocationField';
import { dataValidator, joiErrorParser } from 'dataValidator';
import validateSearchForm from '@Utils/validateSearchForm';
import getCallback from 'getCallback';
import t from 'prop-types';
import { pushDataLayerAlertCreated } from 'datalayer';

const Joi = require('@hapi/joi');

// TODO: HOC or Class for this component and Search form?
class JobAlertsForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      email: '',
      frequency: '_none',
      consent: false,
      submitInProgress: false,
      userData: {},
      errors: {},
    }
    // TODO: To check regular functions use compare to arrow functions.
    this.getValidationSchema = this.getValidationSchema.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
  }

  /**
   * Make a request to My Randstad API, to get the user data, if available.
   * Update email with the received data
   */
  getUserData() {
    const data = {};
    getCallback({
      callback: '@Callbacks/getUserData',
      currentRoute: location.pathname,
      data,
    }).then((response) => {
      if (response && response.data?.email) {
        this.setState((prev) => ({
          ...prev,
          email: response.data.email,
        }));
      }
    });
  }

  /**
   * Component is fully rendered.
   */
  componentDidMount() {
    // Get user email (logged users) and update form value.
    this.getUserData();
  }

  /**
   * Called right after updating occurs. Not called for the initial render.
   * @param prevProps
   *  Stores component props before update.
   * @param prevState
   *  Stores component state before update.
   */
  componentDidUpdate(prevProps,  prevState ) {
    const { email } = this.state;
    if (email !== prevState.email) {
      this.getUserData();
    }
  }

  /**
   * Register custom fields validation for JOI module
   * override validation schema methods.
   * TODO: Replace JOY with inline validation.
   * @return {{schema: *, email: {email: *}}}
   */
  getValidationSchema() {
    const { intl } = this.props;

    const emailValidation = {
      email: Joi.string()
        .email({ tlds: { allow: false } })
        .lowercase()
        .required(),
    };

    const frequencyValidation = {
      frequency: Joi.string()
        .required()
        .disallow('_none'),
    };

    const consentValidation = {
      consent: Joi.boolean()
        .required()
        .strict()
        .invalid(false),
    };

    const validationSchema = Joi.object().keys({
      ...emailValidation,
      ...frequencyValidation,
      ...consentValidation,
    });

    validationSchema.errorOverrides = {
      email: {
        'any.required': intl.formatMessage({ id: 'JobAlerts.Form.Email.Error' }),
        'string.email': intl.formatMessage({ id: 'JobAlerts.Form.Email.Error' }),
        'string.empty': intl.formatMessage({ id: 'JobAlerts.Form.Email.Error' }),
      },
      frequency: {
        'any.required': intl.formatMessage({ id: 'JobAlerts.Form.Frequency.Error' }),
        'any.invalid': intl.formatMessage({ id: 'JobAlerts.Form.Frequency.Error' }),
      },
      consent: {
        'any.invalid': intl.formatMessage({ id: 'JobAlerts.Form.Consent.Error' }),
        'any.required': intl.formatMessage({ id: 'JobAlerts.Form.Consent.Error' }),
      },
    };

    return { email: emailValidation, schema: validationSchema };
  }

  /**
   * Handle form elements change, and update state respectively
   * @param event
   */
  handleChange(event) {
    const { name } = event.target;
    let { value } = event.target;

    if (name === 'consent') {
      value = event.target.checked;
    }

    this.setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /**
   * Manually display a toast component.
   * @param {Number} delay
   *  Delay in ms. after which toast will be hidden.
   */
  displayToast(delay) {
    const toast = document.querySelector('.salary-page [data-rs-toast-anchor="job-alert-subscribed"]');
    toast.classList.add('toast--active');
    // Remove closed toast state if it has been set before.
    toast.classList.remove('closable--closed');

    const hideTimeout = setTimeout(() => {
      toast.classList.add('closable--closed');
      toast.classList.remove('toast--active');
      clearTimeout(hideTimeout);
    }, delay)
  }

  /**
   * Form submit handler:
   * - validate form for the errors
   * - submit data to my-randstad/job-alerts endpoint
   * @param event
   */
  formSubmit = async (event) => {
    event.persist();
    event.preventDefault();
    const { intl, location, history } = this.props;

    const occupationValue = document.querySelector('.job-alerts-form .occupation-field input').value;
    const locationValue = process.env.REACT_APP_COUNTRY !== 'sg'
      ? document.querySelector('.job-alerts-form .location-field input').value
      : '';


    // Validate Occupation and Location fields.
    const { errors, isValid } = await validateSearchForm({
      occupation: occupationValue,
      location: locationValue,
      salary: '',
      language: this.props.intl.locale,
      sourceType: 'JobAlertsForm',
    });

    // Get from values from state.
    // Add occupation and location values to data to send.
    const formValues = {
      email: this.state.email,
      frequency: this.state.frequency,
      consent: this.state.consent
    }
    // Collect data from Occupation/Location fields to pass them to callback.
    const searchFilters = {
      occupation: occupationValue,
      location: locationValue,
    }
    // Update state with an errors from Occupation/Location.
    this.setState({
      errors: {
        ...errors,
      },
    });

    // Validate Email, Select, Consent checkbox.
    const formErrors = dataValidator(formValues, this.getValidationSchema().schema);
    // Switch button state to 'in progress', to prevent multiple clicks on it.
    this.setState({submitInProgress: true});

    // Validate form on errors before making a request.
    if (formErrors || !isValid) {
      // Merge errors from both callbacks
      this.setState({
        errors: {
          ...errors,
          ...formErrors
        },
        submitInProgress: false,
      });
    } else {
      axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/saveJobAlert',
        currentRoute: location.pathname,
        currentLanguage: intl.locale,
        data: {
          formValues,
          searchFilters,
          baseUrl: this.props.baseUrl,
          alertsNameSuffix: intl.formatMessage({ id: 'JobAlerts.AlertName.Suffix' }),
        },
      }).then((response) => {
        const { data } = response;
        if (data?.status === 204 || (process.env.REACT_APP_COUNTRY === 'us' && data?.status === 200)) {
          // Reset form elements state
          this.setState({
            email: '',
            frequency: '',
            consent: false,
          });
          // Trigger Toast component display
          this.displayToast(3000);
          // Set submit button to default state
          this.setState({ submitInProgress: false });
          pushDataLayerAlertCreated();
        } else if (data.joiError && data.errors.length) {
          // If JOI validation error, update errors respectively.
          this.setState({
            errors: joiErrorParser(data.errors),
            submitInProgress: false,
          });
        }
      });
    }
  };

  /**
   * Render error message.
   * TODO: Store this in separate Class? To avoid code duplication, see SearchForm component.
   * @param {String} name
   *   Key of the error message of the input.
   */
  renderError = (name) => (
    this.state.errors[name]?.length > 0
      ? <div className="form-group__feedback">{this.state.errors[name]}</div>
      : ''
  );

  /**
   * Highlight field with error.
   * TODO: Store this in separate Class? To avoid code duplication, see SearchForm component.
   * @param {String} name
   *   Key of the error message of the input.
   */
  highlightFieldError = (name) => (this.state.errors?.[name]?.length > 0 ? 'form-group--error' : '');


  render() {
    const { intl, searchParams } = this.props;
    const { email, frequency, consent, errors, submitInProgress } = this.state;

    return (
      <div id="jobAlertsForm" className="job-alerts-form">
        <div className="content-block__form form-groups form-groups--row">
          <div className="l:flex l:flex-wrap">
            <div className="flex flex-wrap w-full order-1 l:mb-m">
              <OccupationField
                cssClasses="occupation-field form-group__input w-full l:w-1/2 order-1"
                id="occupation-job"
                highlightError={this.highlightFieldError('occupation')}
                renderError={this.renderError('occupation')}
                searchParams={{ occupation: searchParams.occupation }}
              />
              {process.env.REACT_APP_COUNTRY !== 'sg' &&
                <LocationField
                  cssClasses="location-field search-form__input w-full l:w-1/2 l:ml-xxs s:mt-xs l:mt-none l:mt-0 order-2"
                  id="where-job"
                  highlightError={this.highlightFieldError('location')}
                  renderError={this.renderError('location')}
                  searchParams={{ city: searchParams.city, region: searchParams.region }}
                />
              }
            </div>

            <label className="form-group__label hidden--visually" htmlFor="email">
              {intl.formatMessage({ id: 'JobAlerts.Form.Email.Label' })}
              <sup className="form-group__required">*</sup>
            </label>
            <div
              className={`form-group__input flex-grow order-1 flex-basis-0 s:mt-xs l:mt-none ${errors.email ? 'form-group--error' : ''}`}
            >
              <InputField
                type="email"
                name="email"
                id="email"
                required
                onChange={this.handleChange}
                value={email}
                placeholder={intl.formatMessage({ id: 'JobAlerts.Form.Email.Placeholder' })}
              />
              {this.renderError('email')}
            </div>

            <label
              className="form-group__label hidden--visually"
              htmlFor="frequency"
            >
              {intl.formatMessage({ id: 'JobAlerts.Form.Frequency.Label' })}
            </label>
            <div
              className={`form-group__input flex-grow l:ml-xxs order-2 flex-basis-0 s:mt-xs l:mt-none l:mt-0 ${errors.frequency ? 'form-group--error' : ''}`}
            >
              <SelectField
                id="frequency"
                name="frequency"
                className="untouched"
                required
                onChange={this.handleChange}
                value={frequency}
                data-rs-untouched
              >
                <option value="_none">
                  {intl.formatMessage({ id: 'JobAlerts.Form.Frequency.Placeholder' })}
                </option>
                <option value="daily">
                  {intl.formatMessage({ id: 'JobAlerts.Form.Frequency.Daily' })}
                </option>
                <option value="weekly">
                  {intl.formatMessage({ id: 'JobAlerts.Form.Frequency.Weekly' })}
                </option>
                <option value="monthly">
                  {intl.formatMessage({ id: 'JobAlerts.Form.Frequency.Monthly' })}
                </option>
              </SelectField>
              {this.renderError('frequency')}
            </div>
            <div
              className={`content-block__form form-group__input order-5 w-full ${errors.consent ? 'form-group--error' : null}`}
            >
              <label className="selection-control selection-control--checkbox">
              <span className="selection-control__input">
                <Checkbox
                  name="consent"
                  id="consent"
                  onChange={this.handleChange}
                  checked={consent}
                  required
                />
              </span>
                <span
                  className="selection-control__label"
                  dangerouslySetInnerHTML={{ __html: `${intl.formatMessage({ id: 'JobAlerts.Form.Consent.Label' })}` }}
                />
              </label>
              {this.renderError('consent')}
            </div>
            <div className="l:ml-xxs s:mt-xs l:mt-none order-4">
              <Button
                className={`${submitInProgress ? 'button--preloader button--off-white button--disabled' : ''} button button--filled button--icon button--full-width-to-icon`}
                disabled={submitInProgress}
                onClick={this.formSubmit}
                id="submitConsent"
              >
                <span className="button__text">
                  {intl.formatMessage({ id: 'JobAlerts.Form.Button.Text' })}
                </span>
                <span className="dots"></span>
                {!submitInProgress &&
                  <span className="icon" aria-hidden="true">
                    <svg>
                      <use
                        xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#arrow-right-30"
                      />
                    </svg>
                  </span>
                }
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

JobAlertsForm.propTypes = {
  /** Form action base url. */
  baseUrl: t.string.isRequired,
  searchParams: t.shape({
    occupation: t.string,
    region: t.string,
    city: t.string,
    salary: t.string,
  }),
};

JobAlertsForm.defaultProps = {
  searchParams: {
    occupation: '',
    region: '',
    city: '',
    salary: '',
  },
};

export default injectIntl(withRouter(JobAlertsForm));
